import '../../index.scss';

const Loader = () => {
  const div = document.createElement('div');
  div.setAttribute('id', 'loader');
  div.classList.add('loading-indicator');
  div.classList.add('invisible');
  return div;
};

const enableLoader = () => {
  document.getElementById('loader')?.classList.add('visible');
};

const disableLoader = () => {
  document.getElementById('loader')?.classList.remove('visible');
};

export { enableLoader, disableLoader };

export default Loader;
